import { Children, CSSProperties, PropsWithChildren } from "react";
import { GlobalToken, theme } from "antd";
import { useScrollTop } from "src/hooks/useScrollTop";

export function FixedHeaderScrollBody(
  props: PropsWithChildren<{
    style?: CSSProperties;
    matchRight?: boolean;
    disableEffect?: boolean;
  }>
) {
  const { token } = theme.useToken();
  const [scrollRef, scrollTop] = useScrollTop();
  const [header, ...body] = Children.toArray(props.children);
  const hasScroll =
    (scrollRef.current?.scrollHeight || 0) >
    (scrollRef.current?.clientHeight || 0);
  const isScrolling = scrollTop > 4;
  const paddingRight = hasScroll && props.matchRight ? 16 : 0;
  return (
    <div style={containerStyle(token, props.style)}>
      <div style={{ width: "100%", paddingRight }}>{header}</div>
      <div style={shadowWrapperStyle(token)}>
        {isScrolling && !props.disableEffect && (
          <div style={shadowInsertStyle(token)} />
        )}
        <div style={scrollParentStyle(token)} ref={scrollRef}>
          {body}
        </div>
      </div>
    </div>
  );
}
const containerStyle: DynamicCss = (_, style) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflow: "auto",
  position: "relative",
  ...style,
});

const shadowWrapperStyle: DynamicCss = (_) => ({
  flex: 1,
  overflow: "hidden",
});

const shadowInsertStyle: DynamicCss = (token) => ({
  backgroundColor: "transparent",
  boxShadow: `inset 0 1px 1.5px ${token.colorBgBase}`,
  height: 1,
  left: 0,
  overflow: "visible",
  width: "100%",
});

const scrollParentStyle: DynamicCss = (_) => ({
  height: "100%",
  overflow: "auto",
  overflowX: "hidden",
});

type DynamicCss = (token: GlobalToken, style?: CSSProperties) => CSSProperties;
